<template>
  <div
    :id="id"
    ref="collapseEl"
    class="collapse"
    :role="role"
    v-bind="parentAttr"
    data-testid="bs-collapse"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'b-collapse',
  props: {
    id: {
      type: String,
      required: true,
    },
    accordion: {
      type: String,
      default: null,
    },
    role: {
      type: String,
      default: 'tabpanel',
    },
  },
  computed: {
    parentAttr() {
      if (!this.accordion) return {};
      return { 'data-bs-parent': `#${this.accordion}` };
    },
  },
};
</script>
